<template>
  <ul class="ul-container">
    <li>
      <positionLi v-if="content.contentType === 'position'" :content="content.content"></positionLi>
      <contentIndex v-else :bookContent="content.content"></contentIndex>
    </li>
  </ul>
</template>

<script>
/*
无序列表
*/
import positionLi from "./positionLi.vue";
export default {
  name: "ulTemplate",
  components: {
    contentIndex: () => import("../../index.vue"), //解决递归加载组件报错
    positionLi,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      activeTabs1: 0,
      activeTabs2: 0,
    }
  },
  methods: {
    activeTabs1Handle(index) {
      this.activeTabs1 = index;
      this.activeTabs2 = 0;
    },
    activeTabs2Handle(index) {
      this.activeTabs2 = index;
    }
  }
}
</script>

<style lang="scss" scoped>
.ul-container {
  list-style: outside;
  padding-left: 30rem;

  li{

    &::marker{
      color: #8CB894;
    }
  }
}
</style>